import {
    EnumInfoUTypes,
    EnumLanguages,
    EnumLogLevel,
    EnumMFAMethods,
    EnumNotificationDeliveryOptions,
    EnumNotificationStatuses,
    EnumNotificationTemplateEditingMode,
    EnumPopupShowStatuses,
    EnumPrintingType,
    EnumSystemOptionDataTypes,
    EnumSystemOptions,
    EnumUserLoginStatus,
    EnumYesNo,
    HistoryEventTypesEnum
} from '@core/framework/sysenums.enum';

export const Resources_ES =
{
    Pages:
    {
        login: 'Iniciar sesión en el sistema',
        logout: 'Cerrar sesión',
        credentials_activity_status: 'Estado de actividad del usuario',
        notificationshistory: 'Informe de notificaciones',
        notification_dispatches: 'Envíos de notificaciones',
        notification_servers: 'Servidores de notificación',
        notification_templates: 'Plantillas de notificación',
        notifications: 'Notificaciones',
        system_options: 'Opciones del sistema',
        credential_login_history: "Informe del historial de inicio de sesión",
        request_history: "Solicitar historial",
        credentials_report: 'Informe de credenciales',
        credentials_creation: 'Nueva asignación de credenciales',
        data_views: 'Gestión de vistas de la base de datos',
        menu: 'Menú',
        remote_request_history: "Historial de peticiones remotas",
        NotificationViewComponent: 'Notificación',
        PrintBoxDialogComponent: 'Imprimir',
        SignBoxDialogComponent: 'Firmar documento',
        ImageBoxDialogComponent: 'Imagen',
        PhotoBoxDialogComponent: 'Foto',
        PasswordManageComponent: 'Gestión de credenciales',
        CredentialsActivityStatusComponent: 'Estado de actividad del usuario',
        NotificationsHistoryComponent: 'Informe de notificaciones',
        PreviewDialogComponent: 'Vista previa',
        NotificationDispatchComponent: 'Envío de notificaciones',
        NotificationDispatchListComponent: 'Envíos de notificaciones',
        NotificationServerComponent: 'Servidor de notificaciones',
        NotificationServerListComponent: 'Servidores de notificación',
        NotificationTemplateListComponent: 'Plantillas de notificación',
        NotificationTemplateComponent: 'Plantilla de notificación',
        HtmlBoxDialogComponent: 'Editor HTML',
        NotificationTestDialogComponent: 'Prueba de notificación',
        NotificationPreviewDialogComponent: 'Vista previa de la notificación',
        SystemOptionsComponent: 'Opciones del sistema',
        AddSystemOptionDialogComponent: 'Añadir opción',
        BarcodeBoxDialogComponent: 'Escanear código de barras/código QR',
        CredentialLoginHistoryComponent: "Informe del historial de inicio de sesión",
        RequestHistoryListComponent: "Solicitar historial",
        RequestHistoryComponent: "Solicitar",
        RemoteRequestHistoryListComponent: "Historial de solicitudes remotas",
        RemoteRequestHistoryComponent: "Solicitud remota",
        WelcomeUserDialogComponent: "Mensaje de bienvenida",
        HistoryViewComponent: 'Historial de cambios del documento',
        SystemCredentialsComponent: 'Informe de credenciales',
        SystemCredentialsCreationComponent: 'Nueva asignación de credenciales',
        WelcomeMessageConfigDialogComponent: 'Notificación de bienvenida',
        DataViewListComponent: 'Vistas de datos',
        MenuButtonListComponent: 'Menú principal',
        ShareDialogComponent: 'Compartir',
    },
    Lists:
    {
        Languages:
            [
                {
                    Value: EnumLanguages.Hebrew,
                    Text: "Hebreo/עברית",
                },
                {
                    Value: EnumLanguages.English,
                    Text: "Inglés/אנגלית"
                },
                {
                    Value: EnumLanguages.Spanish,
                    Text: "Español/ספרדית"
                },
            ],

        NotificationDeliveryOptions: [
            {
                Value: EnumNotificationDeliveryOptions.Email,
                Text: 'Correo electrónico',
                ID: 0
            },
            {
                Value: EnumNotificationDeliveryOptions.SMS,
                Text: 'SMS',
                ID: 1
            },     
            {
                Value: EnumNotificationDeliveryOptions.WhatsApp,
                Text: 'WhatsApp',
                ID: 3
            }
        ],
        NotificationDispatchDeliveryOptions: [
            {
                Value: EnumNotificationDeliveryOptions.Email,
                Text: 'Correo electrónico'
            },
            {
                Value: EnumNotificationDeliveryOptions.SMS,
                Text: 'SMS'
            },     
            {
                Value: EnumNotificationDeliveryOptions.WhatsApp,
                Text: 'WhatsApp'
            },
            {
                Value: EnumNotificationDeliveryOptions.PushMessage,
                Text: 'Push'
            },
        ],
        NotificationTemplateEditingModes: [
            {
                Value: EnumNotificationTemplateEditingMode.None,
                Text: 'Ninguna',
                ID: 0,
                SortOrder: 1
            },
            {
                Value: EnumNotificationTemplateEditingMode.Preview,
                Text: 'Solo vista previa',
                ID: 4,
                SortOrder: 2
            },
            {
                Value: EnumNotificationTemplateEditingMode.EditPrefix,
                Text: 'Editar prefijo',
                ID: 1,
                SortOrder: 3
            },
            {
                Value: EnumNotificationTemplateEditingMode.EditBody,
                Text: 'Editar cuerpo',
                ID: 3,
                SortOrder: 4
            },
        ],
        UserCreationOptions: [
            {
                Value: EnumNotificationDeliveryOptions.Email,
                Text: 'Correo electrónico',
                ID: 0
            },
            {
                Value: EnumNotificationDeliveryOptions.SMS,
                Text: 'Teléfono',
                ID: 1
            }
        ],
        WelcomeDeliveryOptions: [
            {
                Value: EnumNotificationDeliveryOptions.Email,
                Text: 'Correo electrónico',
                ID: 0,
                SortOrder: 1
            },
            {
                Value: EnumNotificationDeliveryOptions.SMS,
                Text: 'SMS',
                ID: 1,
                SortOrder: 2
            },   
            {
                Value: EnumNotificationDeliveryOptions.WhatsApp,
                Text: 'WhatsApp',
                ID: 3,
                SortOrder: 3
            },
            {
                Value: EnumNotificationDeliveryOptions.DontSend,
                Text: 'No enviar',
                ID: 4,
                SortOrder: 4
            }
        ],
        NotificationTypes: [
            {
                Value: EnumNotificationDeliveryOptions.Email,
                Text: 'Correo electrónico',
                SortOrder: 1,
                index: 0,
                text: 'Correo electrónico',
                Name: EnumNotificationDeliveryOptions.Email
            },
            {
                Value: EnumNotificationDeliveryOptions.SMS,
                Text: 'SMS',
                SortOrder: 2,
                index: 1,
                text: 'SMS',
                Name: EnumNotificationDeliveryOptions.SMS
            },
            {
                Value: EnumNotificationDeliveryOptions.PushMessage,
                Text: 'Mensaje push',
                SortOrder: 3,
                index: 2,
                text: 'Mensaje push',
                Name: EnumNotificationDeliveryOptions.PushMessage
            },
            {
                Value: EnumNotificationDeliveryOptions.WhatsApp,
                Text: 'WhatsApp',
                SortOrder: 4,
                index: 3,
                text: 'WhatsApp',
                Name: EnumNotificationDeliveryOptions.WhatsApp
            },
            {
                Value: EnumNotificationDeliveryOptions.Share,
                Text: 'Compartir',
                SortOrder: 4,
                index: 3,
                text: 'Compartir',
                Name: EnumNotificationDeliveryOptions.Share
            }
        ],
        NotificationStatuses:
            [
                {
                    Value: EnumNotificationStatuses.Draft,
                    Text: "Borrador"
                },
                {
                    Value: EnumNotificationStatuses.Sending,
                    Text: "Enviando"
                },
                {
                    Value: EnumNotificationStatuses.Failure,
                    Text: "Fallo"
                },
                {
                    Value: EnumNotificationStatuses.Sent,
                    Text: "Enviado"
                },
            ],
        NotificationPredefinedSmtpServers: [
            {
                Text: "Office 365",
                SMTPServer: "smtp.office365.com",
                SMTPPort: 587,
                SMTPUseSSL: true
            },
            {
                Text: "Gmail",
                SMTPServer: "smtp.gmail.com",
                SMTPPort: 111,
                SMTPUseSSL: true
            },
            {
                Text: "SendGrid",
                SMTPServer: "smtp.sendgrid.com",
                SMTPPort: 111,
                SMTPUseSSL: false
            }
        ],
        NotificationPredefinedSmsServers: [
            {
                Text: "InforU",
                SMSEndpoint: "https://uapi.inforu.co.il/SendMessageXml.ashx",
                SMSToken: 111,
                SMSEndPointIsInforU: EnumInfoUTypes.InforU
            },
            {
                Text: "Unicell",
                SMSEndpoint: "http://api.soprano.co.il/",
                SMSToken: 222,
                SMSEndPointIsInforU: EnumInfoUTypes.Unicell
            }
        ],
        MFAMethods:
            [
                {
                    Value: EnumMFAMethods.None,
                    Text: "Ninguno"
                },
                {
                    Value: EnumMFAMethods.Email,
                    Text: "Correo electrónico"
                },
                {
                    Value: EnumMFAMethods.SMS,
                    Text: "SMS"
                },
                {
                    Value: EnumMFAMethods.WhatsApp,
                    Text: "WhatsApp"
                }
            ],
        ExportMenuItems: [
            {
                SortOrder: 0,
                Value: 1,
                Text: "Excel"
            },
            {
                SortOrder: 1,
                Value: 2,
                Text: "Imprimir"
            }
        ],
        PopupShowStatuses: [
            {
                Value: EnumPopupShowStatuses.None,
                Text: "Ninguno"
            },
            {
                Value: EnumPopupShowStatuses.ToShow,
                Text: "Por mostrar"
            },
            {
                Value: EnumPopupShowStatuses.Showed,
                Text: "Mostrados"
            }
        ],
        InfoUTypes: [
            {
                Value: EnumInfoUTypes.Unicell,
                Text: "Unicell"
            },
            {
                Value: EnumInfoUTypes.InforU,
                Text: "InforU"
            }
        ],
        SystemOptions: [
            {
                Value: EnumSystemOptions.AppNameHE,
                Text: 'Nombre de la aplicación Hebreo'
            }, {
                Value: EnumSystemOptions.AppNameEN,
                Text: 'Nombre de la aplicación Inglés'
            }, {
                Value: EnumSystemOptions.AppURL,
                Text: 'URL de la aplicación'
            }, {
                Value: EnumSystemOptions.SessionTimeout,
                Text: 'Tiempo de espera de la sesión'
            }, {
                Value: EnumSystemOptions.SessionExpiry,
                Text: 'Expiración de la sesión'
            }, {
                Value: EnumSystemOptions.EnableRequestLogging,
                Text: 'Activar el registro de solicitudes'
            }, {
                Value: EnumSystemOptions.EnableRemoteLogging,
                Text: 'Activar el registro remoto'
            }, {
                Value: EnumSystemOptions.ShowExpiredTimeoutAlert,
                Text: 'Mostrar alerta de tiempo expirado',
                DataType: EnumSystemOptionDataTypes.Boolean,
                SectionName: 'Framework'
            }, {
                Value: EnumSystemOptions.ShowAlmostExpiredTimeoutAlert,
                Text: 'Mostrar alerta de tiempo casi expirado'
            }, {
                Value: EnumSystemOptions.IsSupportedCredentialsManagement,
                Text: 'Gestión de credenciales de asistencia'
            }, {
                Value: EnumSystemOptions.IsSupportedUserWelcome,
                Text: 'Bienvenida al usuario de asistencia'
            }, {
                Value: EnumSystemOptions.IsSupportedPasswordChange,
                Text: 'Cambio de contraseña de asistencia'
            }, {
                Value: EnumSystemOptions.IsSupportedPasswordRecovery,
                Text: 'Recuperación de contraseña de asistencia'
            }, {
                Value: EnumSystemOptions.IsSupportedLoginByOTP,
                Text: 'Acceso de asistencia mediante OTP'
            }, {
                Value: EnumSystemOptions.IsSupportedLoginByPassword,
                Text: 'Acceso de asistencia mediante contraseña'
            }, {
                Value: EnumSystemOptions.IsAutoCreateCredentials,
                Text: 'Crear credenciales automáticamente'
            }, {
                Value: EnumSystemOptions.AutoCreateCredentialsType,
                Text: 'Crear automáticamente el tipo de credenciales'
            }, {
                Value: EnumSystemOptions.IsRequireTaxNumberForOTP,
                Text: 'Requerir número de identificación fiscal para OTP'
            }, {
                Value: EnumSystemOptions.PasswordChangeIntervalDays,
                Text: 'Intervalo de cambio de contraseña, días'
            }, {
                Value: EnumSystemOptions.PasswordComplexityLen,
                Text: 'Longitud de la complejidad de la contraseña'
            }, {
                Value: EnumSystemOptions.PasswordComplexityMinChars,
                Text: 'Complejidad de la contraseña Símbolos de caracteres mínimos'
            }, {
                Value: EnumSystemOptions.PasswordComplexityMinDigits,
                Text: 'Complejidad de la contraseña Símbolos de dígitos mínimos'
            }, {
                Value: EnumSystemOptions.BadLoginAttemptBeforeLock,
                Text: 'Inicio de sesión incorrecto. Intento antes del bloqueo'
            }, {
                Value: EnumSystemOptions.BadLoginAttemptsCheckIntervalMinutes,
                Text: 'Inicio de sesión incorrecto. Intervalo de comprobación de intentos, minutos'
            }, {
                Value: EnumSystemOptions.BadLoginAttemptLockouIntervalMinutes,
                Text: 'Inicio de sesión incorrecto. Intervalo de bloqueo de intentos, minutos'
            }, {
                Value: EnumSystemOptions.XFrameOptions,
                Text: 'Opciones de bloqueo de XFrame'
            }, {
                Value: EnumSystemOptions.IsDeployedBehindLoadBalancer,
                Text: 'Desplegado tras equilibrador de carga / proxy'
            }, {
                Value: EnumSystemOptions.IsSupportNotificationMethodEmail,
                Text: 'Método de notificación de asistencia por correo electrónico'
            }, {
                Value: EnumSystemOptions.IsSupportNotificationMethodSMS,
                Text: 'Método de notificación de asistencia por SMS'
            }, {
                Value: EnumSystemOptions.IsSupportNotificationMethodWhatsApp,
                Text: 'Método de notificación de asistencia por WhatsApp'
            }, {
                Value: EnumSystemOptions.RetentionPeriodRequests,
                Text: 'Periodo de retención de solicitudes'
            }, {
                Value: EnumSystemOptions.RetentionPeriodRemoteRequests,
                Text: 'Periodo de retención de solicitudes remotas'
            }, {
                Value: EnumSystemOptions.RetentionPeriodNotifications,
                Text: 'Período de retención de notificaciones'
            }, {
                Value: EnumSystemOptions.RetentionPeriodSessions,
                Text: 'Periodo de retención de las sesiones'
            }, {
                Value: EnumSystemOptions.SessionFingerprintFreezeTimeout,
                Text: 'Tiempo de espera para congelar la huella digital de la sesión (minutos)'
            },
        ],
        UserLoginStatuses: [
            {
                Value: EnumUserLoginStatus.All,
                Text: "Todos"
            },
            {
                Value: EnumUserLoginStatus.Success,
                Text: "Éxito"
            },
            {
                Value: EnumUserLoginStatus.Failure,
                Text: "Fallo"
            }
        ],
        IsSuccessStatuses: [
            {
                Value: true,
                Text: "Éxito"
            },
            {
                Value: false,
                Text: "Fallo"
            },
        ],
        HistoryEventTypesEnum: [
            {
                Value: HistoryEventTypesEnum.FieldChange,
                Text: "Campo cambiado"
            },
            {
                Value: HistoryEventTypesEnum.RowAdded,
                Text: "Fila añadida"
            },
            {
                Value: HistoryEventTypesEnum.RowDeleted,
                Text: "Fila eliminada"
            },
            {
                Value: HistoryEventTypesEnum.Special,
                Text: "Especial"
            }
        ],
        YesNo:
        [
            {
                Value: EnumYesNo.Yes,
                Text: 'Sí'
            },
            {
                Value: EnumYesNo.No,
                Text: 'No'
            }
        ],
        PageTypes: [
            {
                Value: EnumPrintingType.None,
                Text: 'Ninguno'
            },
            {
                Value: EnumPrintingType.Report,
                Text: 'Informe'
            },
            {
                Value: EnumPrintingType.Entity,
                Text: 'Entidad'
            }
        ],
        LogLevels: 
        [
            {
                Value: EnumLogLevel.Warning,
                Text: 'Aviso'
            },{
                Value: EnumLogLevel.Info,
                Text: 'Info'
            },{
                Value: EnumLogLevel.Error,
                Text: 'Error'
            },
        ]
    },
    Translations:
    {
        lblLanguage: "Idioma",
        lblUserName: "Nombre de usuario",
        lblPassword: "Contraseña",
        titleLogin: "Inicio de sesión en el sistema",
        btnLogin: "Iniciar sesión",
        btnLogout: 'Cerrar sesión',
        btnChangePassword: 'Cambiar contraseña',
        btnContactUs: "Contacta con nosotros",
        btnRecoverPassword: 'Contraseña olvidada',
        lblSaveCredentials: 'Recuérdame',
        titleLogout: "Cerrar sesión",
        titleLogoutLong: "Sesión cerrada con éxito",
        titleLogoutLast: "Te estamos redirigiendo a la pantalla de inicio de sesión",
        titleSessionExpiredTitle: "Sesión caducada",
        titleSessionExpired: "Se ha cerrado tu sesión por inactividad o por un cambio en las credenciales de usuario en el servidor. Por favor, accede de nuevo",
        titleChangePasswordTitle: "Cambiar contraseña",
        titleChangePassword: "Introduce una nueva contraseña. La contraseña debe ser robusta y seguir las normas establecidas por tu departamento de informática",
        titleChangePasswordTitle2: "Cambiar contraseña caducada",
        titleException: "Error del sistema",
        titleExceptionLong: "Los detalles del error se muestran más abajo. Por favor, envíalos al administrador del sistema.\nSe ha producido un error inesperado:",
        titleComingSoonTitle: "Esta característica estará disponible próximamente",
        titlePasswordChanged: 'La contraseña se ha cambiado correctamente. Por favor, usa tu nueva contraseña para iniciar sesión de nuevo',
        titleIdentification: 'Identificación del usuario',
        titlePasswordEntry: 'Nueva entrada de contraseña',
        titleRecoverPasswordTitle: 'Recuperar contraseña olvidada',
        titleWelcomePasswordTitle: 'Primer inicio de sesión en el sistema',
        titleRecoverPassword1: 'Introduce tu nombre de usuario',
        titleRecoverPassword2: 'Puedes recuperar tu contraseña olvidada, siempre que tengas acceso al correo electrónico o teléfono que está guardado en tu cuenta',
        titleRecoverPassword3: 'Para cambiar la contraseña, por favor, introduce el código de verificación que te enviamos',
        titleRecoverPassword4: 'Introduce una nueva contraseña. La contraseña debe ser robusta y seguir las normas establecidas por tu departamento de informática.',
        titleWelcomePassword2: '¡Bienvenido/a! Por favor, introduce el nombre de usuario y el código de verificación que has recibido, para proceder a configurar tu nueva contraseña',
        titleWelcomePassword3: "Introduce una nueva contraseña. La contraseña debe ser robusta y seguir las normas establecidas por tu departamento de informática. A partir de ahora, usarás esta contraseña para entrar en el sistema",
        btnReEntry: "Volver a iniciar sesión",
        genOK: 'OK',
        genYes: "Sí",
        genNo: "No",
        genCancel: "Cancelar",
        genNoData: "No existen datos",
        genPrint: 'Imprimir',
        genSign: 'Firmar',
        genReset: 'Resetear',
        genTakePhoto: 'Hacer foto',
        genSavePhotos: 'Guardar fotos',
        genDownload: 'Descargar',
        msgSignHere: 'Por favor, traza tu firma dentro del cuadrado',
        msgSignatureRequired: 'Debes introducir tu firma para continuar',
        msgPasswordsDontMatch: 'La contraseña y la confirmación de la contraseña no coinciden',
        errorNetwork: "Error de comunicación con el servidor - comprueba tu conexión de red",
        errorSessionExpired: "Sesión caducada por inactividad",
        errorUserInvalid: "Los datos de usuario han cambiado. Por favor, accede de nuevo",
        errorNotInitialized: "No se ha podido iniciar la sesión porque los ajustes del sistema no se han cargado correctamente. Por favor, vuelve a cargar la página",
        errorUnexpected: "@@@Ha ocurrido un error inesperado del servidor@@@: {0}",
        errorUnauthorized: "El usuario no está autorizado para esta operación",
        errorPasswordExpired: "La contraseña ha caducado. Por favor, elige una contraseña diferente",
        msgFinishEditing: "Por favor, termina de editar la línea actual antes de añadir la nueva",
        errorUserNameNotFound: "Nombre de usuario no encontrado",
        errorIsNotExistsPhoneAndEmail: "No se ha definido un correo electrónico ni un teléfono. Ponte en contacto con el servicio de asistencia técnica",
        errorSessionIsFrozen: "La sesión se ha congelado por usar la misma credencial en otro dispositivo",
        lblDay1: "Domingo",
        lblDay2: "Lunes",
        lblDay3: "Martes",
        lblDay4: "Miércoles",
        lblDay5: "Jueves",
        lblDay6: "Viernes",
        lblDay7: "Sábado",
        lblDay1s: "Dom",
        lblDay2s: "Lun",
        lblDay3s: "Mar",
        lblDay4s: "Mie",
        lblDay5s: "Jue",
        lblDay6s: "Vie",
        lblDay7s: "Sáb",
        msgSuccess: "Operación completada con éxito",
        msgNotPerformed: "No se puede completar la operación",
        lblTimes: 'momentos',
        lblUser: "Usuario estándar",
        btnCancelDocument: 'Cancelar documento',
        lblBy: 'Por',
        titleCreatedBy: 'Creado por',
        titleCreated: 'Creado',
        titleCreatedAt: 'Creado en',
        titleAgo: 'Ago',
        lblAgo: 'ago',
        lblSearch: 'Búsqueda',
        lblCloseSearch: 'Cerrar búsqueda',
        lblColumnChooser: 'Mostrar selector de columnas',
        lblColumnHiding: 'Alternar ocultar columnas',
        lblShowGridFilter: 'Mostrar filtros avanzados',
        lblHideGridFilter: 'Ocultar filtros avanzados',
        lblExcel: 'Exportar a Excel',
        lblPdf: 'Exportar a PDF',
        lblViewList: 'Ver como lista de tarjetas',
        lblViewGrid: 'Ver como tabla',
        lblDisplayUserName: 'Nombre de usuario',
        lblLastUseDate: 'Última acción en',
        lblLastUseBefore: 'Última acción antes de',
        progressIndicator: 'Transfiriendo datos.. Por favor, espere',
        lblUpdated: 'Actualizado',
        lblNoSorting: '- Por defecto -',
        lblVersion: 'Versión',
        lblDateIsNull: "La fecha es nula",
        lblDateApproximate: "{0} {1} {2}",
        f702: "menos de un minuto",
        f703: "5 minutos",
        f704: "10 minutos",
        f705: "15 minutos",
        f706: "media hora",
        f707: "menos de una hora",
        f709: "hora y media",
        f710: "más de dos horas",
        f711: "{0} horas",
        f712: "día",
        f713: "dos días",
        f714: "{0} días",
        f715: "más de una semana",
        f716: "más de dos semanas",
        f717: "{0} semanas",
        f718: "más de un mes",
        f720: "dos meses",
        f721: "{0} meses",
        f722: "más de un año",
        f723: "más de dos años",
        f724: "{0} años",
        f725: "menos de un día",
        lblOldPassword: 'Contraseña antigua',
        lblNewPassword1: 'Nueva contraseña',
        lblNewPassword2: 'Confirmar contraseña',
        lblRecoveryType: 'Método de recuperación de contraseña',
        lblRecoveryPhone: 'Número de teléfono para recuperar la contraseña',
        lblRecoveryEmail: 'Dirección de correo electrónico para la recuperación de la contraseña',
        btnSendNotificationDispatch: 'Enviar',
        btnSendRecoveryCode: 'Enviar código de verificación',
        btnCheckUserName: 'Recuperar contraseña',
        btnBackToLogin: 'Volver a la página de inicio de sesión',
        lblRecoveryToken: 'Código de verificación',
        btnResend: 'Enviar de nuevo',
        btnSaveChanges: 'Guardar cambios',
        btnGeneratePassword: 'Generar contraseña',
        btnCreateCredentials: 'Crear credenciales',
        btnUnlockUser: 'Desbloquear usuario',
        lblDisplayUsername: 'Mostrar nombre de usuario',
        lblDisplayUserDescription: 'Mostrar descripción del usuario',
        lblCredentialsNotExist: 'Usuario aún no creado',
        lblPendingWelcome: 'Usuario pendiente de activación a través del enlace de bienvenida',
        titleUserInformation: 'Información para el usuario',
        errorMaxSizeUploadError: 'El tamaño de algunos archivos seleccionados es mayor que {0} y se excluyen de forma automática de la selección.',
        msgFileSizeRestriction: 'El tamaño máximo del archivo es {0}.',
        btnSelectFiles: 'Elegir archivos',
        btnMakePhoto: 'Hacer foto',
        lblAttachFileSize: 'Tamaño del archivo',
        lblFilters: 'Filtros',
        lblAt: 'En',

        lblObjectName: 'Nombre del objeto',
        lblIsOverride: 'Es anulado',
        lblValidation: 'Es válido',
        lblDViewsDBDuration: 'Duración original',
        lblXViewsDBDuration: 'Duración anulada',
        lblCheckPerformance: 'Comprobar el rendimiento',
        lblValidateViews: 'Validar la estructura',
        lblViewError: 'Error',

        lblLoginOTPSendMethod: 'Enviar contraseña de un solo uso a través de',
        lblLoginOTPEmail: 'Dirección de correo electrónico para enviar la contraseña de un solo uso',
        lblLoginOTPPhone: 'Número de teléfono para enviar la contraseña de un solo uso',
        lblLoginOTPOTP: 'Contraseña de un solo uso',
        lnkLoginByOTP: 'Iniciar sesión con contraseña de un solo uso',
        msgNotificationSent: 'La notificación está enviada',
        btnLoginOtpSendOtp: 'Enviar contraseña',
        lnkLoginByPassword: 'Iniciar sesión mediante contraseña',

        lblApply: 'Aplicar',
        lblTaxNumber: 'Número de identificación fiscal',

        lblIsActive: 'Activo',
        lblEmail: 'Correo electrónico',
        lblPhone: 'Teléfono',
        lblIsPendingWelcome: 'Pendiente de Bienvenida',
        lblIsOnline: 'Está en línea',
        lblIsLockedOut: 'Está bloqueado',
        lblCreateCredentials: 'Crear credenciales',
        lblCredentialFilter: 'Filtro de credenciales',

        msgRouteNotFound: 'Ruta no encontrada',
        btnReload: 'Recargar',
        lblHideColumn: 'Ocultar columna',
        lblShowHiddenColumns: 'Mostrar columnas ocultas',

        lblName: 'Nombre',
        lblDescription: 'Descripción',

        msgLoading: "Procesando, por favor espere",
        lblSentDate: "Fecha de envío",
        lblSentBy: "Enviado por",
        lblEntryID: "ID",
        lblFromAddress: "De la dirección",
        lblFromDisplayAddress: "Del nombre",
        lblAddress: "Dirección",
        lblSubject: "Asunto",
        lblMailBody: "Cuerpo",
        lblDeliveryOption: "Opción de envío",
        lblSendNotificationBy: "Enviar notificación por",
        lblUsernameCreationOption: 'Creación del nombre de usuario por',
        lblStatus: "Estado",
        lblToAddress: "Para",
        lblCCAddress: "CC",
        lblBccAddress: "BCC",
        lblFailureDescription: "Descripción del fallo",
        lblNotificationTemplate: "Nombre de la plantilla",
        lblFrom: "De ",
        lblUntil: "Hasta ",

        lblAdd: "Añadir",
        lblClear: "Limpiar",
        lblCompactMode: "Modo compacto",

        lblSessionAlmostExpiredTitle: "La sesión expirará pronto",
        lblSessionAlmostExpiredPrompt: "Se ha detectado un largo periodo de inactividad. Su sesión expirará pronto",
        lblSessionExpiredTitle: "Sesión expirada",
        lblFirstDate: "Primera fecha",
        lblLastDate: "Última fecha",
        lblSessionExpiredPrompt: "Su sesión ha expirado. Se le redirigirá automáticamente a la página de inicio de sesión.",

        lblNotificationContent: "Notificación de contenido",
        lblGeneral: "General",
        lblOptions: "Opciones",
        lblCustom: "Personalizado",

        lblMFACode: "Código",
        titleMFACodeOnEmailSent: "La contraseña de un solo uso ha sido enviada a su correo electrónico. Introdúzcala más abajo",
        titleMFACodeOnPhoneSent: "La contraseña de un solo uso ha sido enviada a su móvil. Introdúzcala más abajo",

        lblMFAMethod: "Autentificación multifactor",
        Month_1: "Enero",
        Month_2: "Febrero",
        Month_3: "Marzo",
        Month_4: "Abril",
        Month_5: "Mayo",
        Month_6: "Junio",
        Month_7: "Julio",
        Month_8: "Augosto",
        Month_9: "Septiembre",
        Month_10: "Octubre",
        Month_11: "Noviembre",
        Month_12: "Diciembre",

        lblExport: "Exportar",
        lblCredentialType: "Tipo de credencial",
        lblIsRestrictByIP: "Restringir por IP",
        lblIsExcludeFromMFA: "Excluir de la MFA",
        lblIPRangeStart: "Inicio del rango IP",
        lblIPRangeEnd: "Fin del rango IP",
        lblIPErrorMessage: "Una dirección IP debe tener un formato &#34;000.000.000.000&#34;",
        msgIPRangesIsEmpty: "Debe añadir al menos una dirección/rango IP",
        msgIPRangeIsEmpty: "Introduzca una dirección/rango IP válido",
        msgPasswordMinLength: "La longitud de la contraseña debe ser de al menos {0} símbolos.",
        msgPasswordMinCountDigits: "La contraseña debe contener al menos {0} dígitos.",
        msgPasswordMinCountLetters: "La contraseña debe contener al menos {0} letras.",
        msgPasswordComplexityRequirement: "La longitud de la contraseña debe ser de al menos {0} símbolos, con un mínimo de {1} dígitos y {2} letras.",
        errorOnlyImageAllowed: "Solo se permiten imágenes.",
        btnClose: "Cerrar",
        lblPhoto: "Foto",

        lblDragAndDrop: "Puede arrastrar y soltar archivos aquí",
        errorRequiredMessage: "Campo obligatorio",
        titleDuplicate: "Duplicar",
        lblAllNotifications: "Todas las notificaciones",

        lblSMTPServer: "Servidor SMTP",
        lblSMTPPort: "Puerto SMTP",
        lblSMTPUserName: "Nombre de usuario SMTP",
        lblSMTPPassword: "Contraseña SMTP",
        lblSMTPUseSSL: "SMTP usa SSL",
        lblSMSEndpoint: "Punto final SMS",
        lblSMSUserName: "Nombre de usuario SMS",
        lblSMSPassword: "Contraseña SMS",
        lblSMSToken: "Token SMS",
        lblSMSEndPointIsInforU: "Proveedor de SMS",

        titleTemplateInformation: "Información sobre la plantilla de notificación",
        titleEmailInformation: "Ajustes de la plantilla de correo electrónico",
        lblFromEmail: "Del correo electrónico",
        lblFromEmailDisplay: "Desde la pantalla de correo electrónico",
        titlePhoneInformation: "Ajustes de la plantilla SMS",
        lblNotificationServer: "Servidor de notificaciones",
        lblFromPhone: "Desde el teléfono",
        lblSMSBody: "Cuerpo del SMS",
        titlePushMessagesInformation: "Configuración de la plantilla de mensajes push",
        lblPushMessageBody: "Cuerpo del mensaje push",
        lblHTMLBody: "Cuerpo HTML",
        btnSave: 'Guardar',
        titleDelete: 'Eliminar',
        lblUseDefault: 'Usar por defecto',
        lblNoUnreadMessages: 'No hay mensajes no leídos',
        lblTo: 'Para',
        lblPushMessageContent: 'Contenido del mensaje push',
        lblSmsMessageContent: 'Contenido del mensaje SMS',
        lblIsAutomatic: 'Es automático',
        lblSystem: 'Sistema',
        lblPopupShowStatus: 'Estado de la ventana emergente',
        lblEmailContent: 'Contenido del correo electrónico',
        btnShowInEditor: 'Mostrar en el editor',
        titleLeavePageConfirmation: 'Se perderán los datos, ¿quiere continuar?',
        btnLogOff: 'Cerrar sesión',
        btnStayConnected: 'Permanecer conectado',
        btnGoToHomePage: 'Ir a la página de inicio',
        lblReadDate: 'Fecha de lectura',
        msgDeleteNotificationTemplateQuestion: 'La plantilla de notificación podría ser usada por la aplicación. ¿Está seguro de que quiere eliminarla?',
        lblNotificationServerWrong: 'La configuración del servidor de notificación es incorrecta. Por favor, realice los cambios e inténtelo de nuevo',
        msgInvalidEmail: 'El correo electrónico no es válido o tiene un formato incorrecto',
        btnTestServer: 'Servidor de prueba',
        lblMIDIsMissing: "Falta el MID",
        lblEnterMID: "Introduzca el nuevo código MID.",
        btnShowPreview: "Mostrar vista previa",
        lblIsServer: "Servidor",
        lblIsClient: "Cliente",
        lblModuleName: "Módulo",
        lblLogin: "Inicio de sesión",
        lblFramework: "Marco",
        lblOption: "Opción",
        lblValue: "Valor",
        lblSectionName: "Valor",
        lblAddOption: 'Añadir opción',
        msgOptionAlreadyExists: 'La opción ya existe',
        msgOptionEmpty: 'La opción {0} está vacía',
        lblBadLogin: 'Inicio de sesión incorrecto',
        msgRemoveOption: "¿Está seguro de que quiere eliminar la opción '{0}'?",
        titleEmailConfiguration: "Configuración del correo electrónico",
        titleSMSConfiguration: "Configuración de SMS",
        msgDeleteNotificationServerQuestion: "El servidor de notificaciones podría usarse en la aplicación. ¿Está seguro de que quiere eliminarlo?",
        msgNoData: "Sin datos",
        lblEmailHeader: "Encabezado del correo electrónico",
        lblConfigure: "Configurar",
        lblDefaultFromAddressForInforU: "Test",
        lblDefaultFromAddressForUnicel: "0509999999",
        lblInforUFromPhoneValidationTooltip: "Por favor, introduzca un número de teléfono de la lista blanca de nombre de hasta 11 caracteres en inglés",
        lblNotifications: "Notificaciones",
        lblMinimize: "Minimizar",
        lblShowMore: "Mostrar más",
        titleWhatsAppInformation: "Ajustes de la plantilla de WhatsApp",
        lblWhatsAppBody: "Cuerpo del mensaje de WhatsApp",
        lblWhatsAppApiKey: "Clave API de WhatsApp",
        lblWhatsAppEndpoint: "Punto final de WhatsApp",
        titleWhatsAppConfiguration: "Configuración de WhatsApp",
        titleNotificationDispatchList: "Lista de envío de notificaciones",
        titleNotificationServerList: "Lista de servidores de notificación",
        titleNotificationTemplateList: "Lista de plantillas de notificación",

        lblPoweredBy: "Desarrollado por Menahel4U",
        titleChooseOption: "Elija una opción",
        titleWebAPIAllowedIPs: "IPs permitidas",
        lblIpAddress: "Dirección IP",
        lblLoginDate: "Fecha de inicio de sesión",
        lblPrint: "Imprimir",
        lblDateFrom: 'Fecha desde',
        lblDateTo: 'Fecha hasta',
        lblDate: "Fecha",
        msgCouldNotStartVideoError: 'La cámara no está disponible',
        msgCameraPermissionDenied:'Permiso de cámara denegado',
        lblCameraModeVideo: 'Video',
        lblCameraModePhoto: 'Foto',
        titlePreview: 'Vista previa',
        msgLogoutQuestion: '¿Está seguro de que quiere cerrar la sesión?',
        lblGroupPanel: 'Arrastrar columna al grupo',
        lblExpandAll: 'Ampliar todo',
        lblMultiEmailError: 'El valor no es válido. Usar el símbolo ; como separador de correo electrónico',
        msgPhotoMinCountError: 'El recuento mínimo es {0}',
        msgPhotoMaxCountError: 'El recuento máximo es {0}',
        lblRestoreDefaultView: "Restaurar vista por defecto",
        lblStartDate: "Fecha de inicio",
        lblDuration: "Duración",
        lblController: "Controlador",
        lblAction: "Acción",
        lblMethod: "Método",
        lblStatusCode: "Código de estado",
        lblRequestData: "Solicitar datos",
        lblQueryString: "Cadena de consulta",
        lblBody: "Cuerpo",
        lblResponse: "Respuesta",
        msgTextCopied: "Texto copiado",
        lblCopy: "Copiar",
        btnGoToLoginHistory: "Ir al historial de inicio de sesión",
        btnGoToRequestsHistory: "Ir al historial de solicitudes",
        btnManageCredentials: "Gestionar credenciales",
        btnGoToCredentialsReport: "Ir al informe de credenciales",
        btnWelcomeUser: "Enviar mensaje de bienvenida",
        lblTestFromPhone: "Desde el teléfono",
        lblHistory: "Registro de cambios",
        lblNewValue: "Nuevo valor",
        lblOldValue: "Valor antiguo",
        lblFieldCaption: "Campo",
        lblDocumentCaption: " Documento",
        lblHistoryLineAdded: "{0} {1} fue añadida.",
        lblHistoryLineRemoved: "{0} {1} fue eliminada.",
        lblHistoryLineNumber: "{0} {1}",
        lblHistoryNotFound: "No se han encontrado cambios.",
        lblHistoryChangeAdded: "{0} {1} fue creado",
        lblHistoryChangeRemoved: "{0} {1} fue eliminado",
        msgLoadingPDF: 'Cargando archivo PDF...',
        lblImpersonatedBy: 'Personificado por',
        lblIsUserCustomTemplate: "Plantilla personalizada del usuario",
        msgIsUserCustomTemplateEnable: "Si la opción 'Editable' está activada, podrá cambiar la plantilla manualmente, pero el sistema no podrá actualizarla de forma automática.",
        btnEnableEditable: "Activar editable",
        btnDisableEditable: "Desactivar editable",
        msgScreenSizeChangedRefresh: 'El tamaño de la pantalla ha cambiado. Por favor, actualice la ventana del navegador.',
        msgOrientationChangedRefresh: 'La orientación ha cambiado. Por favor, actualice la ventana del navegador.',
        lblDeliveryMethod: 'Método de envío',
        lblNotificationDispatch: 'Envío de notificación',
        lblRecipients: 'Destinatarios',
        lblPreview: 'Vista previa',
        msgRecipientsAreEmpty: 'Debe añadir al menos un destinatario',
        lblCreatedBy: 'Creado por',
        btnCancelNotifications: 'Cancelar notificaciones',
        lblCancelNotificationsPrompt: 'Va a cancelar las notificaciones Push no leídas. ¿Quiere continuar?',
        lblNotificationMessage: 'Mensaje de notificación',
        lblIsDeleted: 'Eliminado',
        lblShareMethodEmail: 'Correo electrónico',
        lblShareMethodSms: 'SMS',
        lblShareMethodWhatsapp: 'WhatsApp',
        lblShareMethodPrint: 'Imprimir',
        lblShare: 'Compartir',
        lblEntityType: 'Tipo de entidad',
        lblPageName: 'Página',
        btnSend: 'Enviar',
        lblChooseTemplate: 'Elegir plantilla',
        lblShareMethodDownload: 'Descargar',
        lblShareMethodShare: 'Compartir',
        lblUploadCrystalTemplate: 'Subir plantilla de Crystal',
        lblNotificationTemplateEditingMode: 'Modo de edición del cuerpo',
        msgShareNotificationTemplateNotFoundError: 'Las plantillas de notificación no están configuradas para esta página',
        btnShare: 'Compartir',
        msgNotificationTemplatePrefixNotFoundError: '$PrefixBody$ falta un parámetro',
        lblPrefixBody: 'Cuerpo del prefijo',
        lblIsSharePdf: 'Compartir PDF',
        lblFileNameFormat: 'Formato del nombre del archivo',
        lblEntityBindingPageType: 'Vincular a',
        titleEntityBindingInformation: 'Vinculación de la entidad',
        msgNotificationTemplateFileMissingError: 'Falta la plantilla del informe de Crystal',
        lblSharedFile: 'Archivo compartido',
        msgNotificationTemplateEmptyError: 'No se puede guardar la plantilla vacía',
        lblIsSupportEmail: 'Correo electrónico de asistencia',
        lblIsSupportSMS: 'SMS de asistencia',
        lblIsSupportWhatsapp: 'WhatsApp de asistencia',
        lblIsSupportPush: 'Push de asistencia',
        lblIsSupportSharing: 'Compartir asistencia',
        lblIsShareByEntities: 'Compartir por entidades',
        ttlLogs: "Registros",
        lblObjectType: "Tipo de objeto",
        lblObjectID: "ID del objeto",
        lblLevel: "Nivel",
        lblNotAssigned: "- Sin asignar -",
        msgNotificationSentTo: 'La notificación se ha enviado a {0}',
    }
};